import { Base } from '@studiometa/js-toolkit';

/**
 * FooterList class.
 */
export default class FooterList extends Base {
  static config = {
    name: 'FooterList',
    refs: ['container', 'btn'],
  };

  /**
   * Mounted
   */
  onBtnClick() {
    this.$refs.container.classList.toggle('hidden');
  }
}
